/* eslint-disable no-unused-vars */
import { gameState, config } from '@js/state';
import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

const correctAnswerArray = [3, 4, 2, 2, 1, 1, 3, 1, 1, 3];

const questionArray = [
  [
    [[1], [0]],
    [[2], [0]],
    [[3], [0]],
    [[6], [0]],
  ],
  [
    [[6], [3]],
    [[6], [18]],
    [[12], [6]],
    [[18], [6]],
  ],
  [
    [[1], [8]],
    [[9], [8]],
    [[9], [16]],
    [[16], [9]],
  ],
  [
    [[9], [8]],
    [[9], [4]],
    [[8], [4]],
    [[4], [9]],
  ],
  [
    [[12], [5]],
    [[12], [15]],
    [[3], [5]],
    [[15], [5]],
  ],
  [
    [[13], [9]],
    [[13], [18]],
    [[9], [13]],
    [[13], [5]],
  ],
  [
    [[11], [12]],
    [[6], [11]],
    [[11], [6]],
    [[12], [11]],
  ],
  [
    [[19], [8]],
    [[8], [19]],
    [[24], [19]],
    [[5], [8]],
  ],
  [
    [[17], [7]],
    [[3], [7]],
    [[17], [21]],
    [[17], [4]],
  ],
  [
    [[6], [10]],
    [[26], [30]],
    [[26], [10]],
    [[26], [4]],
  ],
];

const hintLoadingCode = [
  [[3], [5]],
  [[3], [5]],
  [[4], [5]],
  [[7], [10]],
  [[7], [9]],
  [[7], [12]],
  [[7], [12]],
  [[7], [12]],
  [[1], [2]],
  [[1], [2]],
];

let podiumClickCode = 0;
let attempts = 0;
let hintOn = false;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    this.UiSceneID = this.scene.get('UiScene');

    if (gameState.gameAttempts == 0) {
      this.time.delayedCall(
        2000,
        () => {
          this.loadEndSceneImages();
          this.load.start();
        },
        this,
      );
      this.time.delayedCall(
        4000,
        () => {
          this.loadEndSceneRewards();
          this.load.start();
        },
        this,
      );
      this.time.delayedCall(
        8000,
        () => {
          this.loadEndSceneAnims();
          this.load.start();
        },
        this,
      );
    }

    this.add.image(config.width / 2, config.height / 2, 'gameBackground');

    this.qnImage = this.add
      .sprite(640, 254, 'qnImage1')
      .setOrigin(0.5, 0.5)
      .setAlpha(0);

    this.podium1 = this.add.sprite(278, 463, 'podium').setOrigin(0);
    this.podium2 = this.add.sprite(465, 463, 'podium').setOrigin(0);
    this.podium3 = this.add.sprite(652, 463, 'podium').setOrigin(0);
    this.podium4 = this.add.sprite(839, 463, 'podium').setOrigin(0);

    this.cardHolder1 = this.add.sprite(306, 374, 'cardHolder').setOrigin(0);
    this.cardHolder2 = this.add.sprite(493, 374, 'cardHolder').setOrigin(0);
    this.cardHolder3 = this.add.sprite(680, 374, 'cardHolder').setOrigin(0);
    this.cardHolder4 = this.add.sprite(867, 374, 'cardHolder').setOrigin(0);

    this.card1 = this.add.sprite(311, 379, 'defaultCard').setOrigin(0);
    this.card2 = this.add.sprite(498, 379, 'defaultCard').setOrigin(0);
    this.card3 = this.add.sprite(685, 379, 'defaultCard').setOrigin(0);
    this.card4 = this.add.sprite(872, 379, 'defaultCard').setOrigin(0);

    this.light1 = this.add.sprite(328, 508, 'yellowLight').setOrigin(0);
    this.light2 = this.add.sprite(515, 508, 'yellowLight').setOrigin(0);
    this.light3 = this.add.sprite(702, 508, 'yellowLight').setOrigin(0);
    this.light4 = this.add.sprite(889, 508, 'yellowLight').setOrigin(0);

    this.cardMaskImage = this.add
      .sprite(0, 232, 'cardMask')
      .setOrigin(0)
      .setVisible(false);

    this.podiumArray = [this.podium1, this.podium2, this.podium3, this.podium4];
    this.cardArray = [this.card1, this.card2, this.card3, this.card4];
    this.lightArray = [this.light1, this.light2, this.light3, this.light4];

    this.podium1.on('pointerup', this.clickPodium1, this);
    this.podium2.on('pointerup', this.clickPodium2, this);
    this.podium3.on('pointerup', this.clickPodium3, this);
    this.podium4.on('pointerup', this.clickPodium4, this);
    this.cardHolder1.on('pointerup', this.clickPodium1, this);
    this.cardHolder2.on('pointerup', this.clickPodium2, this);
    this.cardHolder3.on('pointerup', this.clickPodium3, this);
    this.cardHolder4.on('pointerup', this.clickPodium4, this);

    this.cardContainer1 = this.add.container(0, 0, [this.cardHolder1, this.card1]);
    this.cardContainer2 = this.add.container(0, 0, [this.cardHolder2, this.card2]);
    this.cardContainer3 = this.add.container(0, 0, [this.cardHolder3, this.card3]);
    this.cardContainer4 = this.add.container(0, 0, [this.cardHolder4, this.card4]);

    this.pod1nr = this.add
      .text(355, 424 - 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2nr = this.add
      .text(542, 424 - 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3nr = this.add
      .text(729, 424 - 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4nr = this.add
      .text(916, 424 - 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.pod1dr = this.add
      .text(355, 424 + 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2dr = this.add
      .text(542, 424 + 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3dr = this.add
      .text(729, 424 + 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4dr = this.add
      .text(916, 424 + 18, '', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.pod1Line = this.add
      .text(355, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2Line = this.add
      .text(542, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3Line = this.add
      .text(729, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4Line = this.add
      .text(916, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.allCardsGroup = this.add.container(0, 0, [
      this.cardContainer1,
      this.cardContainer2,
      this.cardContainer3,
      this.cardContainer4,
      this.pod1nr,
      this.pod2nr,
      this.pod3nr,
      this.pod4nr,
      this.pod1dr,
      this.pod2dr,
      this.pod3dr,
      this.pod4dr,
      this.pod1Line,
      this.pod2Line,
      this.pod3Line,
      this.pod4Line,
    ]);

    this.cardMask = this.cardMaskImage.createBitmapMask();
    this.allCardsGroup.setMask(this.cardMask);

    this.confetti = this.add
      .sprite(0, 0, 'confetti')
      .setOrigin(0.5, 0)
      .setVisible(false)
      .setScale(0.5, 1);

    this.spotlight = this.add
      .sprite(542, 71, 'spotlight')
      .setOrigin(0.5, 0)
      .setAlpha(0)
      .setScale(0);

    this.podnrArray = [this.pod1nr, this.pod2nr, this.pod3nr, this.pod4nr];
    this.poddrArray = [this.pod1dr, this.pod2dr, this.pod3dr, this.pod4dr];
    this.podLineArray = [this.pod1Line, this.pod2Line, this.pod3Line, this.pod4Line];

    this.hint = this.add
      .sprite(80, 650, 'hintStyle1')
      .setVisible(false)
      .setDepth(6)
      .setOrigin(0, 1);

    this.closeHintButton = this.add
      .sprite(445, 450, 'closeHint')
      .setVisible(false)
      .setDepth(6)
      .setInteractive({ cursor: 'pointer' });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, 'overlay')
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false)
      .setInteractive();

    this.hintButton = this.physics.add
      .sprite(80, 650, 'hintFinalAnim')
      .setScale(0.8)
      .setDepth(6);

    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'confettiPop',
      frames: this.anims.generateFrameNames('confetti', {
        start: 0,
        end: 300,
        zeroPad: 0,
        prefix: 'verticalConfetti',
        suffix: '.png',
      }),
      frameRate: 100,
      repeat: 0,
    });

    this.handleHintButton();
    gameState.questionNumber = 2;

    config.audio.newQuestion = this.sound.add('newQuestion').setVolume(0.1);
    config.audio.correctSound = this.sound.add('correctSound').setVolume(0.1);
    config.audio.incorrectSound = this.sound.add('incorrectSound').setVolume(0.3);
    config.audio.confettiSound = this.sound.add('confettiSound').setVolume(0.05);
    config.audio.hintaudio = this.sound.add('hintaudio').setVolume(0.05);

    this.askQuestion();
    this.UiSceneID.q.setTexture('q');
    this.UiSceneID.textHolderTween(1002, 500, 50);

    this.time.delayedCall(5000, () => {}, [], this);
  }

  loadEndSceneImages() {
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image(
      'hover_retryButton',
      'assets/EndSceneAssets/hover_Retry Button.png',
    );
    this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
    this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
    this.load.image(
      'hover_replayButton',
      'assets/EndSceneAssets/hover_replayButton.png',
    );
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
    this.load.image(
      'disable_okayButton',
      'assets/EndSceneAssets/disable_okaybutton.png',
    );
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
  }

  loadEndSceneRewards() {
    this.load.image('rewardName', 'assets/EndSceneAssets/goldenmedal.png');
    this.load.image('compass', 'assets/EndSceneAssets/medal.png');

    this.load.multiatlas(
      'baseCircle',
      'assets/anims/rewardAnims/baseCircleAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'glitter',
      'assets/anims/rewardAnims/glitterAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'rewardLight',
      'assets/anims/rewardAnims/rewardLightAnim.json',
      'assets/anims/rewardAnims/',
    );
  }

  loadEndSceneAnims() {
    this.load.multiatlas(
      'endSpotlight',
      'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
      'assets/EndSceneAssets/spotlight',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
  }

  celebrate() {
    this.tweens.add({
      targets: this.spotlight,
      delay: 0,
      scale: { from: 0, to: 1 },
      alpha: { from: 1, to: 1 },
      ease: 'Cubic',
      duration: 1000,
      onComplete: () => {
        config.audio.confettiSound.play();
        this.confetti.play('confettiPop').setVisible(true);
      },
    });
  }

  popInCards(callback) {
    this.tweens.add({
      targets: this.allCardsGroup,
      delay: 0,
      y: { from: 105, to: 0 },
      ease: 'Cubic',
      duration: 1200,
      onComplete: callback,
    });
  }

  popOutCards(callback) {
    this.tweens.add({
      targets: this.allCardsGroup,
      delay: 0,
      y: { from: 0, to: 105 },
      ease: 'Cubic',
      duration: 1200,
      delayedCall: 1000,
      onComplete: callback,
      onCompleteScope: this,
    });
  }

  resetPodium() {
    for (let i = 0; i < 4; i++) {
      this.cardArray[i].setTexture('defaultCard');
      this.lightArray[i].setTexture('yellowLight');

      this.podnrArray[i].setFill('#2b2b2b');
      this.poddrArray[i].setFill('#2b2b2b');
      this.podLineArray[i].setFill('#2b2b2b');
    }
    podiumClickCode = 0;
  }

  lightBulb(code, colorcode) {
    if (colorcode == 1) {
      if (code == 1) {
        this.light1.setTexture('redLight');
        this.card1.setTexture('wrongCard');
      } else if (code == 2) {
        this.light2.setTexture('redLight');
        this.card2.setTexture('wrongCard');
      } else if (code == 3) {
        this.light3.setTexture('redLight');
        this.card3.setTexture('wrongCard');
      } else if (code == 4) {
        this.light4.setTexture('redLight');
        this.card4.setTexture('wrongCard');
      }
    } else if (colorcode == 2) {
      if (code == 1) {
        this.light1.setTexture('greenLight');
        this.card1.setTexture('correctCard');
      } else if (code == 2) {
        this.light2.setTexture('greenLight');
        this.card2.setTexture('correctCard');
      } else if (code == 3) {
        this.light3.setTexture('greenLight');
        this.card3.setTexture('correctCard');
      } else if (code == 4) {
        this.light4.setTexture('greenLight');
        this.card4.setTexture('correctCard');
      }
    }
  }

  askQuestion() {
    config.audio.newQuestion.play();

    this.enableDisablePodium(0);

    attempts = 0;
    gameState.attempted++;

    this.fillNumbersInCards();
    this.qnImage.setTexture('qnImage' + gameState.questionNumber);

    this.objectFadeInOut(this.qnImage, 500, 0);

    this.popInCards(() => {
      this.enableDisablePodium(1);
    });
  }

  fillNumbersInCards() {
    for (let i = 0; i < 4; i++) {
      if (questionArray[gameState.questionNumber - 1][i][1] == 0) {
        this.podnrArray[i]
          .setText(questionArray[gameState.questionNumber - 1][i][0])
          .setVisible(true)
          .setY(424)
          .setFontSize('32px');
        this.poddrArray[i].setVisible(false);
        this.podLineArray[i].setVisible(false);
      } else {
        this.podnrArray[i]
          .setText(questionArray[gameState.questionNumber - 1][i][0])
          .setVisible(true)
          .setY(424 - 18)
          .setFontSize('24px');
        this.poddrArray[i]
          .setText(questionArray[gameState.questionNumber - 1][i][1])
          .setVisible(true)
          .setY(424 + 18)
          .setFontSize('24px');
        this.podLineArray[i].setVisible(true);
      }
    }
  }

  changeQuestion() {
    attempts = 0;
    this.enableDisablePodium(0);
    this.resetPodium();

    gameState.questionNumber++;

    if (gameState.score >= 5) {
      gameState.gameWin = true;
    }

    if (gameState.score < 5 && gameState.questionNumber < 11) {
      this.askQuestion();
      this.UiSceneID.textHolderTween(1002, 500, 50);
    } else {
      this.UiSceneID.teraRemove();

      this.time.delayedCall(
        1300,
        () => {
          this.UiSceneID.removeProgressBar();
          disablePointerEvents();
          this.scene.stop('GameScene');
          this.scene.start('EndScene');
          this.scene.bringToTop('UiScene');
        },
        [],
        this,
      );
    }
  }

  evaluateResponse() {
    if (podiumClickCode == correctAnswerArray[gameState.questionNumber - 1]) {
      if (hintOn == true) {
        this.hintButton.play('pop_out');
        hintOn = false;
      }
      this.correctResponse();
      config.audio.correctSound.play();
    } else {
      config.audio.incorrectSound.play();

      attempts += 1;

      this.UiSceneID.runWrongUi(attempts);

      if (attempts >= 3) {
        if (hintOn == true) {
          this.hintButton.play('pop_out');
          hintOn = false;
        }

        this.lightBulb(podiumClickCode, 1);

        this.podnrArray[podiumClickCode - 1].setFill('#C22300');
        this.poddrArray[podiumClickCode - 1].setFill('#C22300');
        this.podLineArray[podiumClickCode - 1].setFill('#C22300');

        this.time.delayedCall(
          3500,
          () => {
            this.objectFadeInOut(this.qnImage, 500, 1);
            this.UiSceneID.objectFadeInOut(0, 1000, 0);
            this.popOutCards(() => this.changeQuestion());
          },
          [],
          this,
        );
      } else if (attempts == 1 || attempts == 2) {
        this.incorrectResponse();
      }
    }
  }

  incorrectResponse() {
    this.lightBulb(podiumClickCode, 1);

    this.podnrArray[podiumClickCode - 1].setFill('#C22300');
    this.poddrArray[podiumClickCode - 1].setFill('#C22300');
    this.podLineArray[podiumClickCode - 1].setFill('#C22300');

    this.hintAdding();

    this.time.delayedCall(
      3500,
      () => {
        if (this.overlay.visible == false) {
          this.enableDisablePodium(1);
          this.resetPodium();
        }
      },
      [],
      this,
    );
  }

  correctResponse() {
    this.UiSceneID.runCorrectUi();

    gameState.score++;
    this.lightBulb(podiumClickCode, 2);

    this.podnrArray[podiumClickCode - 1].setFill('#149A53');
    this.poddrArray[podiumClickCode - 1].setFill('#149A53');
    this.podLineArray[podiumClickCode - 1].setFill('#149A53');

    if (podiumClickCode == 1) {
      this.spotlight.setX(355);
      this.confetti.setX(355);
    } else if (podiumClickCode == 2) {
      this.spotlight.setX(542);
      this.confetti.setX(542);
    } else if (podiumClickCode == 3) {
      this.confetti.setX(729);
      this.spotlight.setX(729);
    } else if (podiumClickCode == 4) {
      this.confetti.setX(916);
      this.spotlight.setX(916);
    }

    this.celebrate();

    this.time.delayedCall(
      4500,
      () => {
        this.popOutCards();
        this.resetPodium();
        this.objectFadeInOut(this.qnImage, 500, 1);
        this.objectFadeInOut(this.spotlight, 500, 1);

        this.time.delayedCall(
          1000,
          () => {
            this.changeQuestion();
          },
          [],
          this,
        );
      },
      [],
      this,
    );
  }

  enableDisablePodium(code) {
    if (code == 0) {
      this.podium1.removeInteractive();
      this.podium2.removeInteractive();
      this.podium3.removeInteractive();
      this.podium4.removeInteractive();

      this.cardHolder1.removeInteractive();
      this.cardHolder2.removeInteractive();
      this.cardHolder3.removeInteractive();
      this.cardHolder4.removeInteractive();
    } else if (code == 1) {
      this.podium1.setInteractive({ cursor: 'pointer', pixelPerfect: true });
      this.podium2.setInteractive({ cursor: 'pointer', pixelPerfect: true });
      this.podium3.setInteractive({ cursor: 'pointer', pixelPerfect: true });
      this.podium4.setInteractive({ cursor: 'pointer', pixelPerfect: true });

      this.cardHolder1.setInteractive({ cursor: 'pointer' });
      this.cardHolder2.setInteractive({ cursor: 'pointer' });
      this.cardHolder3.setInteractive({ cursor: 'pointer' });
      this.cardHolder4.setInteractive({ cursor: 'pointer' });
    }
  }

  objectFadeInOut(object, duration, code, delay) {
    if (code == 0) {
      this.tweens.add({
        targets: object,
        delay: delay,
        alpha: { from: 0, to: 1 },
        ease: 'Cubic',
        duration: duration,
        repeat: 0,
        yoyo: false,
      });
    } else if (code == 1) {
      this.tweens.add({
        targets: object,
        delay: delay,
        alpha: { from: 1, to: 0 },
        ease: 'Cubic',
        duration: duration,
        repeat: 0,
        yoyo: false,
      });
    }
  }

  hintAdding() {
    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          if (hintOn == false) {
            this.hintButton.setVisible(true);
            this.hintButton.play('pop');
            hintOn = true;
          }
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({
                cursor: 'pointer',
                pixelPerfect: true,
              });
            },
            [],
            this,
          );
        }
      },
      [],
      this,
    );

    this.time.delayedCall(
      1500,
      function () {
        if (hintOn) {
          this.hintButton.play('breathe');
        }
      },
      [],
      this,
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({
                cursor: 'pointer',
                pixelPerfect: true,
              });
            },
            [],
            this,
          );
        }
      },
      [],
      this,
    );
  }

  handleHintButton() {
    this.hintButton.on(
      'pointerup',
      function (pointer) {
        config.audio.hintaudio.play();
        gameState.hints += 1;
        this.hintButton.play('idle');

        this.UiSceneID.runHintUiAnims();

        if (attempts == 1) {
          this.loadHintTexture();

          this.overlay.setVisible(true).setDepth(5);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(5);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.loadHintTexture();
        }

        this.hintButton.removeInteractive();
      },
      this,
    );

    this.closeHintButton.on(
      'pointerup',
      function (pointer) {
        this.enableDisablePodium(1);
        this.resetPodium();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.setInteractive({ cursor: 'pointer', pixelPerfect: true });
      },
      this,
    );
  }

  loadHintTexture() {
    if (attempts <= 2) {
      this.hint.setTexture(
        'hintStyle' +
          hintLoadingCode[gameState.questionNumber - 1][attempts - 1],
      );
      this.closeHintButton.setPosition(
        80 + this.hint.width + 10,
        650 - this.hint.height - 10,
      );
    }
  }

  clickPodium1() {
    podiumClickCode = 1;
    this.evaluateResponse();
    this.enableDisablePodium(0);
  }
  clickPodium2() {
    podiumClickCode = 2;
    this.evaluateResponse();
    this.enableDisablePodium(0);
  }
  clickPodium3() {
    podiumClickCode = 3;
    this.evaluateResponse();
    this.enableDisablePodium(0);
  }
  clickPodium4() {
    podiumClickCode = 4;
    this.evaluateResponse();
    this.enableDisablePodium(0);
  }

  update() {}
}
